import { useEffect, useState } from "react";
import { getReportsByGroup } from "../actions";
import { removeEmptyFields, resolveErrorMessage } from "../util";

/**
 * hook para buscar dados de relatórios por agrupamento
 * @param {Object} userFilters
 * @param {string} group
 * @returns {{ data: Object|null, loading: boolean, error: string|null }}
 */
const useUserByGroupReportData = (userFilters) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;
    const fetchReports = async () => {
      try {
        if (!userFilters.group) {
          return;
        }
        setLoading(true);
        setError(null);
        setData(null);

        const { selectedMonthYear, ...filters } = userFilters;

        const cleanedFilters = removeEmptyFields(filters);
        const reportParams = {
          ...cleanedFilters,
          ...(selectedMonthYear && {
            month: selectedMonthYear.month() + 1,
            year: selectedMonthYear.year(),
          }),
        };

        const reportData = await getReportsByGroup(reportParams);

        if (!ignore) {
          setData(reportData);
        }
      } catch (e) {
        if (!ignore) {
          const errorMessage = resolveErrorMessage(e);
          setError(errorMessage);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    };

    fetchReports();
    return () => {
      ignore = true;
    };
  }, [userFilters]);

  return { reportData: data, loading, error };
};

export default useUserByGroupReportData;
